<nav class="navbar navbar-expand-lg nav-section">
    <div class="container">	
        <a class="navbar-brand" routerLink="/parking-rate"><img src="assets/images/logo-southbay.svg" class="logo"></a>
       <!--   <a class="ml-auto mr-1"></a>
       <button class="btn btn-success ml-auto mr-1">Always open</button> -->

        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent">
            <span class="navbar-toggler-icon"><i class="ri-menu-3-line"></i></span>
        </button>
        <div class="collapse navbar-collapse flex-grow-0" id="navbarSupportedContent">
            
        </div>
    </div>
</nav>



<section class="section-admin-wrap section-login">
    <section class="section-banner">
        <div class="container">
            <div class="row">
                <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                    <div class="left-box">
                        <h1>Change Password</h1>
                        <form [formGroup]="passwordForm" class="login-container" autocomplete="on" (ngSubmit)="ChangePassword()">
                            <div class="row">
                                <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12  pad-right">
                                    <div class="input-group mb-3">
                                      <div class="input-group-prepend">
                                       
                                      </div>
                                      <input type="password" class="form-control" formControlName="password" autocomplete="on" placeholder="New Password">
                                      <div *ngIf="isValid && formControls.password.errors" class="help-block">
                                        <div *ngIf="formControls.password.errors.required">Password is required</div>
                                        <div *ngIf="formControls.password.errors.minlength">Password must be at least 6 characters</div>
                            
                                      </div>
                                    </div>
                                </div>
                                
                                
                            </div>
                        <div class="row">
                            <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12  pad-right">
                                <div class="input-group mb-3">
                                  <div class="input-group-prepend">
                                    
                                  </div>
                                  <input type="password" class="form-control" formControlName="password_confirmation" autocomplete="on" placeholder="Confirm Password">
                                  <div *ngIf="isValid && formControls.password_confirmation.errors" class="help-block">
                                    <div *ngIf="formControls.password_confirmation.errors.required">Confirm
                                      password is required
                                    </div>
                                    <div *ngIf="formControls.password_confirmation.errors.mustMatch">Password does not match</div>
                                </div>
                                </div>
                               
                        
                            </div>
                            
                        </div>

                        <div class="row">
                            <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-center">
                                <button type="submit" class="btn btn-warning btn-reserve" >Submit</button>
                            </div>
                        </div>
                        
                        </form>
                        
                        
                    </div>
                </div>
            </div>
        </div>
    </section>
</section>
<footer class="footer">
    <div class="container">
        <div class="row">
            <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                <p> &copy; 2020 AC Hotels Airport Parking. All rights reserved</p>
            </div>
            <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                <ul class="navbar">
                    <li><a routerLink="/about"
                        routerLinkActive="active" class="nav-item">About</a></li>
                    <li><a routerLink="/contact"
                        routerLinkActive="active" class="nav-item">Contact</a></li>
                    <li><a routerLink="/terms-privacy"
                        routerLinkActive="active" class="nav-item">Terms & Privacy</a></li>
                    <li><a routerLink="/site-map"
                        routerLinkActive="active" class="nav-item">Sitemap</a></li>
                </ul>
            </div>
        </div>
    </div>
</footer>
